import React from 'react';
import PropTypes from 'prop-types';
import DateSelectorGrid from './DateSelectorGrid';
import { DatePropType } from '../helpers/common';

function convertYearRangeToArray(range) {
  const final = [];
  const { min, max } = range;

  for (let index = min; index < max; index++) {
    final.push(index);
  }

  return final;
}

function DateSelectorYearsView({ onYearChange, selectedYear, yearRange, minDate, maxDate }) {
  const currentDate = new Date(Date.now());

  return (
    <DateSelectorGrid
      current={currentDate.getFullYear()}
      selected={selectedYear}
      onItemClick={(item, key) => onYearChange(item)}
      data={convertYearRangeToArray(yearRange)}
      testPrefix="YearCell"
      minDate={minDate}
      maxDate={maxDate}
      selectedYear={selectedYear}
      type="years"
    />
  );
}

DateSelectorYearsView.propTypes = {
  onYearChange: PropTypes.func,
  yearRange: PropTypes.object.isRequired,
  selectedYear: PropTypes.number,
  minDate: DatePropType,
  maxDate: DatePropType
};

export default DateSelectorYearsView;
